import merge from 'lodash/merge';
import production from './production';

export default merge({}, production, {
  host: 'signin.s-neptune.com',
  favicon: 'cadilac_favicon.ico'
});
